import { authenticatedGetAPI, authenticatedPostAPI } from "../GenericAPICall";
import { StatisticsURL } from "../Services";

export async function followSocialPage(
  url: string,
  contentType: string,
  source: string
) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/social/follow/page",
    {
      url,
      contentType,
      source,
    }
  );
  return res;
}

export async function getFollowingFacebookPages() {
  var res = await authenticatedGetAPI(
    StatisticsURL + "api/social/facebook/pages"
  );
  return res;
}

export async function followGoogleSearchQuery(query: string) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/social/google/search",
    { query }
  );
  return res;
}

export async function getFollowingGoogleSearchQueries() {
  var res = await authenticatedGetAPI(
    StatisticsURL + "api/social/google/searches"
  );
  return res;
}

export async function unfollowGoogleSearchQuery(id: number) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/social/google/search/unfollow",
    {
      id,
    }
  );
  return res;
}

export async function getGoogleSearchQueryDetail(id: number) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/social/google/search/detail",
    {
      id,
    }
  );
  return res;
}

export async function setupDomainRelation(
  domain: string,
  relationType: string
) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/social/domain/relation",
    {
      domain,
      relationType,
    }
  );
  return res;
}

export async function getAllDomainRelations() {
  var res = await authenticatedGetAPI(
    StatisticsURL + "api/social/domain/relation/all"
  );
  return res;
}

export async function createTouchPoint(name: string, ids: any[]) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/social/google/search/flow",
    {
      name: name,
      queryIDs: ids
    }
  );
  return res;
}

export async function getAllTouchPoints() {
  var res = await authenticatedGetAPI(
    StatisticsURL + "api/social/google/search/flows"
  )
  return res;
}
